import httpClient from './Http'

export default {

    getProject(id) {
        return id
            ?  httpClient.get(`/api/pro/project/${id}`)
            :  httpClient.get(`/api/pro/project/init`);
    },

    getProjectsForCurrentUser() {
        return httpClient.get(`/api/pro/project/current-user`);
    },

    getProjectLikesForCurrentUser(pageNumber) {
        var query = '?page=' + pageNumber;
        return httpClient.get(`/api/pro/project/current-user/likes${query}`);
    },

    search(queryStr, skipHistoryPushState) {
        queryStr = queryStr || '';
        let apiPath = `/pro/search/project${queryStr}`;

        let result = httpClient.get('/api' + apiPath);

        if(!skipHistoryPushState) {
            window.history.pushState(null, null, apiPath);
        }

        return result;
    },

    initProjectForm(id) {
        return id
            ?  httpClient.get(`/api/pro/project/${id}?form`)
            :  httpClient.get(`/api/pro/project/init?form`);
    },

    removeProject(id){
        return httpClient.delete(`/api/pro/project/${id}`);
    },

    save(project){
	    return project.id
            ? httpClient.post(`/api/pro/project/${project.id}?form`, project)
            : httpClient.post(`/api/pro/project/?form`, project);
    },

    searchCollaboratorsByName(name) {
	    return httpClient.get(`/api/pro/project/collaborator/search?q=${name}`)
    },

    getProjectLikeInfoForUser(projectId, userId) {
        return httpClient.get(`/api/pro/project/${projectId}/like?user_id=${userId}`);
    },

    getProjectLikeInfo(projectId) {
        return httpClient.get(`/api/pro/project/${projectId}/like`);
    },

    getProjectLikeDetailsForProject(projectId) {
        return httpClient.get(`/api/pro/project/${projectId}/likes`);
    },

    likeProject(projectId) {
        return httpClient.post(`/api/pro/project/${projectId}/like`);
    },

    unlikeProject(projectId) {
        return httpClient.delete(`/api/pro/project/${projectId}/like`);
    },
}



// WEBPACK FOOTER //
// ./src/main/frontend/vue/js/api/ProjectService.js